import { CustomerIcon } from 'components/Atoms/Icon';
import { lazy } from 'react';
import * as routeName from '../route-name';
import * as routePath from '../route-path';

const UserManagement = lazy(() => import('modules/user/User'));
const UserDetailManagement = lazy(() => import('modules/user/Detail'));

export const userRoutes = [
  {
    path: routePath.USER,
    component: UserManagement,
    exact: true,
    name: routeName.USER,
    showMenu: true,
    icon: CustomerIcon,
    breadcrumbs: [{ name: routeName.USER }],
  },
  {
    path: routePath.USER_DETAIL,
    component: UserDetailManagement,
    exact: true,
    name: routeName.USER_DETAIL,
    showMenu: false,
    icon: CustomerIcon,
  },
];
